export interface AdminRouteConfig {
  path: string;
  label: string;
  icon?: string;
}

export const routes = {
  // Auth routes
  login: '/login',

  // Admin routes
  dashboard: '/',
  reviews: '/reviews',
  reviewDetail: '/reviews/:id',
  users: '/users',
  userDetail: '/users/:id',
  catalog: '/catalog',
  catalogNew: '/catalog/new',
  catalogEdit: '/catalog/:id/edit',
  moderation: '/moderation',
} as const;

export type RoutePath = (typeof routes)[keyof typeof routes];

// Navigation items for admin sidebar
export const navItems: AdminRouteConfig[] = [
  {
    path: routes.dashboard,
    label: 'Dashboard',
    icon: 'LayoutDashboard',
  },
  {
    path: routes.reviews,
    label: 'Review Queue',
    icon: 'ClipboardCheck',
  },
  {
    path: routes.users,
    label: 'Users',
    icon: 'Users',
  },
  {
    path: routes.catalog,
    label: 'Catalog',
    icon: 'Library',
  },
  {
    path: routes.moderation,
    label: 'Moderation',
    icon: 'Shield',
  },
];
